import { Booking } from "../bookings/types"
import { BASE_URL } from "../constants"



export const search = async (lastName: string, bookingDate: string, releaseDate: string, county: string): Promise<Booking[]> => {
  if (bookingDate) bookingDate = new Date(bookingDate).toISOString()
  if (releaseDate) releaseDate = new Date(releaseDate).toISOString()
  return fetch(`${BASE_URL}api/bookings/search`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      lastName: lastName || undefined, 
      bookingDate: bookingDate || undefined, 
      releaseDate: releaseDate || undefined, 
      county 
    })
  }).then((response) => {
    if (response.ok) {
      return response.json()
    } else {
      throw new Error('Something went wrong')
    }
  })
}